import React from 'react'
// IMPORT STYLES
import '../../App.css'

const Menu = () => {
  return <h1 className='products'>Menu</h1>
}

export default Menu
